export default class Image {
    constructor(className, config = {}) {
    }
}
